import Qs from "qs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

/**
 * Add a parameter to the URL or remove it if it already exists with the same value.
 * @returns Function to add or remove a parameter.
 */
export const useToggleUrlParameter = () => {
    const { push } = useHistory();

    /**
     * Add or remove a parameter from the URL.
     * @param parameter Parameter name.
     * @param value     Parameter value.
     */
    const toggleUrlParameter = useCallback(
        (parameter: string, value: any) => {
            const current = Qs.parse(window.location.search, { ignoreQueryPrefix: true });
            const { [parameter]: currentValue, ...otherParameters } = current;

            // When the user clicks an already selected value it should be removed instead of added.
            const isSameValue = currentValue === String(value);
            const parameters = isSameValue ? otherParameters : { ...current, [parameter]: value };
            push({ search: Qs.stringify(parameters, { addQueryPrefix: true, arrayFormat: "repeat" }) });
        },
        [push]
    );

    return toggleUrlParameter;
};
